module.exports = __webpack_public_path__ + "static/media/grey-pattern.856f31d9.jpg";